import objectFitImages from 'object-fit-images'
objectFitImages()

import * as components from './components'
import * as directives from './directives'
import * as filters from './filters'
import * as mixins from './mixins'
import * as utils from './utils'

import Breakpoints from './plugins/breakpoints.js'
import Toaster from './plugins/toaster.js'

const LibraryModule = {
  install(Vue) {
    // Register components
    Object.keys(components)
      .forEach(key => Vue.component(`N${key}`, components[key]))

    // Register directives
    Object.keys(directives)
      .forEach(key => Vue.directive(key, directives[key]))

    // Register filters
    Object.keys(filters)
      .forEach(key => Vue.filter(key, filters[key]))

    // Install our breakpoints plugin
    Vue.use(Breakpoints)

    // Install our toaster plugin
    Vue.use(Toaster)
  }
}

// Export library
export default LibraryModule

// Re-Export all packages so they can be imported separately by consumer
export * from './components'
export * from './directives'
export * from './filters'
export * from './mixins'
export * from './utils'
export { default as CoreUiValidationMessages } from './validation/messages'
export { default as CoreUiValidators } from './validation/validators'